<template>
  <div>
    <transactions
      :transaction-class="transactionClass"
      :verbose-name="JSON.parse($route.params.sales) ? 'Retour produit' : 'Renvoi produit'"
      :verbose-name-plural="JSON.parse($route.params.sales) ? 'Retours produits' : 'Renvois produits'"
      ressource="product-returns"
      :colors="colors"
      :add="false"
    ></transactions>
  </div>
</template>

<script>
import { Hk } from '@/node-sdk'

import Transactions from '@/router/view/commercial/components/transactions'

const { ProductReturn } = Hk.Crm
export default {
  name: 'product-returns',

  components: {
    Transactions,
  },

  data() {
    return {
      transactionClass: null,
      colors: {
        waiting: 'warning',
        canceled: 'danger',
        delivered: 'success',
      },
    }
  },

  mounted() {
    this.transactionClass = ProductReturn
  },
}
</script>

<style></style>
